// step5.js - Corporate Room/Suite Issues (FINAL CORRECTED - matches template exactly)
import React from 'react';
import ModernDataTable from '../ui/ModernDataTable';

const Step5 = ({ corporateRoomItems, setCorporateRoomItems, defaultDateTime, enablePhotoUpload, referenceNo, sectionName, dataTableRef }) => {
  const corporateRoomFields = [
    {
      name: 'dateRaised', // ← CRITICAL: Was 'timeRaised' - now matches template
      type: 'datetime',
      label: 'Date Raised',
      header: 'Date Raised',
      required: true,
      validationMessage: 'Please enter when the corporate room/suite issue was first reported',
      hint: 'Record the exact time when the corporate room or suite issue was discovered or first reported to staff.'
    },
    {
      name: 'description',
      type: 'textarea',
      label: 'Description of Issue',
      header: 'Description',
      placeholder: 'Describe the corporate room/suite issue that occurred...',
      required: true,
      validationMessage: 'Please provide a detailed description of the corporate room/suite issue',
      hint: (
        <div>
          <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Describe the issue including:</p>
          <ul style={{ margin: 0, paddingLeft: '1rem' }}>
            <li>Specific nature of the problem</li>
            <li>Impact on corporate guests or event</li>
            <li>Any equipment or services affected</li>
            <li>Urgency level for resolution</li>
            <li>Guest complaints or feedback received</li>
          </ul>
        </div>
      )
    },
    {
      name: 'location', // ← CRITICAL: Was 'roomNumber' - now matches template
      type: 'text',
      label: 'Location',
      header: 'Location',
      placeholder: 'e.g. Suite 12, Corporate Box A, Room 305',
      required: true,
      validationMessage: 'Please specify the room or suite location',
      hint: 'Enter the specific room, suite, or corporate box location where the issue occurred.'
    },
    {
      name: 'guestsAffected',
      type: 'number',
      label: 'Number of Guests Affected',
      header: 'Guests Affected',
      placeholder: 'Enter number of corporate guests impacted',
      min: 0,
      max: 500,
      validationMessage: 'Please enter the number of guests affected (0-500)',
      hint: 'Enter the approximate number of corporate guests who were affected by this issue.',
      displayTransform: (value) => value > 0 ? `${value} guests` : 'None'
    },
    {
      name: 'actionsTaken',
      type: 'textarea',
      label: 'Actions Taken',
      header: 'Actions Taken',
      placeholder: 'Describe actions taken to resolve the corporate room/suite issue...',
      validationMessage: 'Please describe the actions taken to address the issue',
      hint: (
        <div>
          <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document all actions taken including:</p>
          <ul style={{ margin: 0, paddingLeft: '1rem' }}>
            <li>Immediate response to guest concerns</li>
            <li>Staff or departments contacted</li>
            <li>Equipment repairs or replacements</li>
            <li>Alternative arrangements provided</li>
            <li>Compensation or goodwill gestures offered</li>
            <li>Follow-up actions planned</li>
          </ul>
        </div>
      )
    }
    // ← REMOVED: issueCategory field (not in template)
  ];

      return (
    <ModernDataTable
      suppressTitle={true}
      data={corporateRoomItems}
      setData={setCorporateRoomItems}
      fields={corporateRoomFields}
      addButtonText="Add Corporate Room/Suite Issue"
      emptyMessage="No corporate room/suite issues added yet."
      truncateLines={2}
      defaultDateTime={defaultDateTime}
      enablePhotoUpload={enablePhotoUpload}
      referenceNo={referenceNo}
      sectionName={sectionName}
      ref={dataTableRef}
      />
  );
};

export default Step5;